import Helper from "../../Helper";
import { Submittal } from "../../models/Submittal";
import { SubmittalFilterInfo } from "../Materials/SubmittalFilterInfo";

export function getSubmittals(
    team_subdomain: string,
    project_token: string,
    timezone: string,
    submittalFilter: SubmittalFilterInfo = new SubmittalFilterInfo()
): Promise<{ submittals: Submittal[]; totalCount: number }> {
    const urlString =
        Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects") +
        `/projects/${project_token}/submittals`;

    const url = new URL(urlString);

    url.search = submittalFilter.toUrlSearchParams().toString();
    return Helper.plotFetch(url.toString(), {}, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return { submittals: [], totalCount: 0 };
        })
        .then((response) => {
            return {
                submittals: response.submittals.map((sub: any) => Submittal.fromApiObject(sub, timezone)),
                totalCount: response.total_count,
            };
        })
        .catch(() => {
            return { submittals: [], totalCount: 0 };
        });
}
